import { useState } from "react";
import { withClientContext } from "~/apollo/client";
import {
  useSetDdqProdOpsRequestDueDateMutation,
  useSetDdqProdOpsRequestOwnersMutation,
  useSetDdqProdOpsRequestSubmitByDateMutation,
} from "~/graphql/supergraphHooks";

export type UseDetailsTabActionsResult = {
  onSetOwners: (ownerIds: string[]) => void;
  onSetDueDate: (dueAt: string) => void;
  onSetSubmitByDate: (dueDate: string) => void;
  isSettingOwners: boolean;
  isSettingDueDate: boolean;
  isSettingSubmitByDate: boolean;
  ownersError: string | null;
  dueDateError: string | null;
  submitByDateError: string | null;
};

export const useDetailsTabActions = (workflowId: string): UseDetailsTabActionsResult => {
  const [ownersError, setOwnersError] = useState<string | null>(null);
  const [dueDateError, setDueDateError] = useState<string | null>(null);
  const [submitByDateError, setSubmitByDateError] = useState<string | null>(null);

  const [setOwnersMutation, { loading: isSettingOwners }] =
    useSetDdqProdOpsRequestOwnersMutation({
      context: withClientContext("federation"),
      refetchQueries: ["GetDdqProdOpsQueue"],
    });
  const [setDueDateMutation, { loading: isSettingDueDate }] =
    useSetDdqProdOpsRequestDueDateMutation({
      context: withClientContext("federation"),
      refetchQueries: ["GetDdqProdOpsQueue"],
    });
  const [setSubmitByDateMutation, { loading: isSettingSubmitByDate }] =
    useSetDdqProdOpsRequestSubmitByDateMutation({
      context: withClientContext("federation"),
      refetchQueries: ["GetDdqProdOpsQueue"],
    });

  const onSetOwners = (ownerIds: string[]) => {
    setOwnersError(null);
    setOwnersMutation({ variables: { workflowId, ownerIds } }).catch((error: unknown) => {
      setOwnersError(error instanceof Error ? error.message : "Something went wrong.");
    });
  };

  const onSetDueDate = (dueAt: string) => {
    setDueDateError(null);
    setDueDateMutation({ variables: { workflowId, dueAt } }).catch((error: unknown) => {
      setDueDateError(error instanceof Error ? error.message : "Something went wrong.");
    });
  };

  const onSetSubmitByDate = (dueDate: string) => {
    setSubmitByDateError(null);
    setSubmitByDateMutation({ variables: { workflowId, dueDate } }).catch((error: unknown) => {
      setSubmitByDateError(error instanceof Error ? error.message : "Something went wrong.");
    });
  };

  return {
    onSetOwners,
    onSetDueDate,
    onSetSubmitByDate,
    isSettingOwners,
    isSettingDueDate,
    isSettingSubmitByDate,
    ownersError,
    dueDateError,
    submitByDateError,
  };
};
